<template>
 <div class="appointmentcontainer pb100">
   <banner/>
  <crumbs/>
  <div class="container">
   <type-screen modelType="appointment"
      :menu-id="this.$route.query.columnId"
      :fixed-type-list="fixedTypeList"
      @typeObj="selectType"/>
    <ul class="ul-model1 clearfix">
      <li v-for="(item, index) in List" :key="index">
        <a @click="detaillink(item.columnId, item.id)">
          <collect collect-style="iconcollect3"
                   :is-select="item.isCollect"
                   :count="item.collect"
                   @changecount="changeCollect"
                   :menu-id="item.columnId"
                   :business-id="item.id"
                   :title="item.name"
                   :image="item.image"
                   :url="'/appointmentdetail?columnId=' + item.columnId + '&id=' + item.id"/>
          <span class="status" :class="'status' + item.status.code">{{ item.status.description }}</span>
          <div class="imgbox">
            <img class="imgtop" :src="getImage(item.image)" alt="">
          </div>
          <div class="txtbox">
            <h2 class="textover">{{ item.name }}</h2>
            <div class="descbox">
              <p class="textover">日期：<span>{{ getTime(item.beginTime) }}</span></p>
              <p class="textover" v-if="item.address !== undefined && item.address !== ''">地点：<span>{{ item.address }}</span></p>
              <p class="textover" v-if="item.organizer !== undefined && item.organizer !== ''">主办：<span>{{ item.organizer }}</span></p>
              <p class="textover clearfix" v-if="item.number === 0">
                <em class="fl">直接前往</em>
              </p>
              <p class="textover clearfix" v-else>
                <em class="fl">{{ surplusname }}：<span>{{ item.surplus }}</span>{{ unit }}</em><em class="fr">{{ allname }}：<span>{{ item.number }}</span>{{ unit }} </em>
              </p>
            </div>
          </div>
        </a>
      </li>
    </ul>
    <nodata v-show="nodataflag"/>
    <el-pagination
      @current-change="handleCurrentChange"
      :page-size="appointmentParam.limit"
      :pager-count="5"
      :current-page.sync="currentPage"
      layout="prev, pager, next"
      :total="listTotal"
      class="pagemodel1">
    </el-pagination>
  </div>
 </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import typeScreen from '@/components/typescreen/index'
import nodata from '@/components/nodata/index'
import { scrollAnimation } from '@/utils/index'
import { getAppointmentList } from '@/api/appointment/index'
import { timeFormat } from '@/utils/validate'
import Collect from '@/components/amount/collect'
import { getListAmount } from '@/api/datavolume/index'
export default {
  name: 'appointment',
  meta: {
    showHeader: true
  },
  components: {
    Collect,
    typeScreen,
    crumbs,
    banner,
    nodata
  },
  computed: {
    adSlot () {
      return this.$store.state.adSlot.list
    }
  },
  watch: {
    adSlot (val) {
      if (val) {
        this.slotList = val
        this.getData()
      }
    }
  },
  data () {
    return {
      surplusname: '余票',
      allname: '总票数',
      unit: '张',
      slotList: [],
      appointmentParam: {
        page: 1,
        limit: 12,
        columnId: '',
        types: '',
        activityType: '',
        beginTimeSegment: '',
        codes: '',
        phone: this.$cookie.get('wlymobilephone')
      },
      currentPage: 1,
      nodataflag: false,
      List: [],
      listTotal: 0,
      fixedTypeList: [{
        'id': 1,
        'name': '时间',
        'fixedtypeId': 1,
        'fixedtypename': 'beginTimeSegment',
        'showFlag': 0,
        'children': [{
          'id': 1,
          'name': '全部',
          'code': ''
        }, {
          'id': 2,
          'name': '今天',
          'code': 1
        }, {
          'id': 3,
          'name': '本周',
          'code': 2
        }, {
          'id': 4,
          'name': '本月',
          'code': 3
        }]
      }, {
        'id': 2,
        'name': '状态',
        'fixedtypeId': 2,
        'fixedtypename': 'status',
        'showFlag': 0,
        'children': [{
          'id': 1,
          'name': '全部',
          'code': ''
        }, {
          'id': 2,
          'name': '未开始',
          'code': 0
        }, {
          'id': 3,
          'name': '进行中',
          'code': 1
        }, {
          'id': 4,
          'name': '已结束',
          'code': 2
        }]
      }]
    }
  },
  mounted () {
    // this.screenWidth = document.body.clientWidth
    // if (this.screenWidth < 768) {
    //   let conditionCArr = this.$refs.condition.children
    //   for (let i = 0; i < conditionCArr.length; i++) {
    //     let Carrli = conditionCArr[i].getElementsByTagName('li')
    //     let ulW = 0
    //     for (let j = 0; j < Carrli.length; j++) {
    //       ulW += Carrli[j].offsetWidth
    //     }
    //     conditionCArr[i].getElementsByTagName('ul')[0].style.width = ulW + 'px'
    //   }
    // }
    this.appointmentParam.columnId = this.$route.query.columnId
    // this.getAppointment()
    if (this.$store.state.adSlot.list.length !== 0) {
      this.slotList = this.$store.state.adSlot.list
      this.getData()
    }
  },
  methods: {
    getData () {
      this.slotList.forEach(item => {
        if (item.slotName === 'ticketText') {
          item.adDetails.forEach(items => {
            if (parseInt(items.adLink) === parseInt(this.$route.query.columnId) && items.adCode === 'surplus') {
              this.surplusname = items.adName
            }
            if (parseInt(items.adLink) === parseInt(this.$route.query.columnId) && items.adCode === 'allname') {
              this.allname = items.adName
            }
            if (parseInt(items.adLink) === parseInt(this.$route.query.columnId) && items.adCode === 'unit') {
              this.unit = items.adName
            }
          })
        }
      })
    },
    changeCollect (val) {
      this.List.forEach((item) => {
        if (item.id === val.id) {
          item.collect = val.count
          item.isCollect = val.isSelect
        }
      })
    },
    defaultamout (list) {
      list.forEach(item => {
        if (item.collect === undefined) item.collect = 0
        if (item.isCollect === undefined) item.isCollect = 'false'
      })
    },
    getTime (val) {
      let hhmm = timeFormat(val, 'yymmddhhmm').split(' ')[1]
      if (hhmm === '00:00') {
        return timeFormat(val, 'yymmdd')
      } else {
        return timeFormat(val, 'yymmddhhmm')
      }
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    /* 获取活动列表 */
    getAppointment () {
      getAppointmentList(this.appointmentParam).then(res => {
        if (res.data.list.status === 200) {
          this.listTotal = res.data.list.data.total
          if (this.listTotal === 0) {
            this.nodataflag = true
          } else {
            this.nodataflag = false
          }
          getListAmount(this.$route.query.columnId, {'p': this.$cookie.get('wlymobilephone')}).then((resamout) => {
            if (resamout.data.data.length !== 0) {
              resamout.data.data.forEach(amout => {
                res.data.list.data.rows.forEach(item => {
                  if (amout.dataId === item.id) {
                    item.collect = amout.collect
                    item.isCollect = amout.isCollect
                  }
                })
              })
              this.defaultamout(res.data.list.data.rows)
            } else {
              this.defaultamout(res.data.list.data.rows)
            }
            this.List = res.data.list.data.rows
          })
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    /* 筛选条件 */
    selectType (obj) {
      console.log(obj)
      if (obj.codes !== undefined) {
        this.appointmentParam.codes = obj.codes.toString()
      }
      this.appointmentParam.activityType = obj.activityType
      this.appointmentParam.types = obj.customTypeId
      this.appointmentParam.beginTimeSegment = obj.beginTimeSegment
      this.appointmentParam.status = obj.status
      this.appointmentParam.page = 1
      this.currentPage = 1
      this.getAppointment()
    },
    // 分页触发
    handleCurrentChange (val) {
      this.appointmentParam.page = val
      const currentY = document.documentElement.scrollTop || document.body.scrollTop
      scrollAnimation(currentY, 0)
      this.getAppointment()
    },
    detaillink (columnId, id) {
      if (this.$route.query.subhomepage !== undefined) {
        this.$router.push({path: '/appointmentdetail', query: {columnId: columnId, id: id, subhomepage: this.$route.query.subhomepage}})
      } else {
        this.$router.push({path: '/appointmentdetail', query: {columnId: columnId, id: id}})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/view/appointment/list.vue